import {
	type FrontendPlacementMessage,
	type AnyFrontendStage,
} from '@post-office/message-maker-browser/types';

import { noValidation } from '@post-office/message-maker-browser/message-helpers';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

import {
	PlacementFrontend,
	type PlacementRenderProps,
} from '@post-office/browser--jira-empanada/issue-navigator-placement';

import { PreviewPanelResizeSpotlight } from '../../../components/PreviewPanelResizeSpotlight';

export type MessageTemplateContext = Record<string, never>;

type RenderProps = MessageTemplateContext & PlacementRenderProps;

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: AnyFrontendStage;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<RenderProps>(),
		Component: ({ isIssuePreviewPanelOpen }) => (
			<PreviewPanelResizeSpotlight isIssuePreviewPanelOpen={isIssuePreviewPanelOpen} />
		),
	},
});
